import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ConceptPage = () => {
  useEffect(() => {
    document.title = 'コンセプト｜さかなの木';
  }, []);

  const strengths = [
    {
      icon: 'ri-fish-line',
      title: '産地直送の新鮮魚介',
      description: '毎日市場から届く新鮮な魚介を、いけじめ・神絞めで丁寧に処理。鮮度と旨味を最大限に引き出します。',
    },
    {
      icon: 'ri-restaurant-line',
      title: '小皿スタイル',
      description: '一品一品を小皿でご提供。お一人様でも多彩な料理をお楽しみいただけ、お酒との相性も抜群です。',
    },
    {
      icon: 'ri-goblet-line',
      title: '豊富な日本酒',
      description: '15種類以上の厳選日本酒を季節ごとにご用意。100mlからお楽しみいただけるので、料理に合わせて様々な銘柄をお試しいただけます。',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="hero-section relative h-[60vh] md:h-[70vh] mt-20">
        <div className="hero-inner relative w-full h-full">
          <img
            className="hero-image absolute inset-0 w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/32cee3297f0b62dfab440b70ecabba3f.webp"
            alt="さかなの木 コンセプト"
          />
          <div className="hero-overlay absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/20"></div>
          <div className="hero-copy absolute inset-0 flex items-center justify-center text-center text-white px-4">
            <div>
              <h2 className="text-4xl md:text-6xl font-bold text-white">CONCEPT</h2>
              <p className="text-lg md:text-xl mt-4 text-white">私たちの想い</p>
            </div>
          </div>
        </div>
      </section>
      <h1 className="text-xs text-center py-1 text-gray-500" style={{ fontSize: '10px', lineHeight: '1.2' }}>コンセプト｜鵜の木で新鮮魚が味わえる海鮮居酒屋｜さかなの木</h1>

      {/* Philosophy Section */}
      <section 
        className="py-20 relative"
      >
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
            alt="背景"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-12 max-w-4xl mx-auto">
            <span className="text-primary text-sm font-bold tracking-wider">OUR PHILOSOPHY</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-6" style={{ color: '#3A3D3F' }}>
              地域密着を大切に一緒に成長していく
            </h2>
            <p className="leading-relaxed text-lg" style={{ color: '#3A3D3F' }}>
              「さかなの木」は、地域の皆様と共に歩み、共に成長していくことを第一に考えています。<br />
              この場所で、この地域で、ずっと愛される存在でありたい。<br />
              そんな想いを込めて、日々営業しております。
            </p>
          </div>
          <div className="max-w-5xl mx-auto">
            <img
              src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/998cc9fdfc3e94f9198a40d52a19a6bf.webp"
              alt="地域密着の想い"
              className="w-full rounded-lg shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* Name Origin Section */}
      <section 
        className="py-20 relative"
      >
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
            alt="背景"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
            <div className="order-2 md:order-1">
              <span className="text-primary text-sm font-bold tracking-wider">NAME ORIGIN</span>
              <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-6" style={{ color: '#3A3D3F' }}>
                名前に込めた想い
              </h2>
              <p className="leading-relaxed mb-6" style={{ color: '#3A3D3F' }}>
                「さかなの木」という店名には、特別な意味が込められています。
              </p>
              <p className="leading-relaxed mb-6" style={{ color: '#3A3D3F' }}>
                「木」という文字は、<strong className="underline decoration-primary decoration-2 underline-offset-4" style={{ color: '#3A3D3F' }}>地域に根を張り、この場所でしっかりと成長していく</strong>という想いを表しています。
              </p>
              <p className="leading-relaxed mb-6" style={{ color: '#3A3D3F' }}>
                木が大地に根を張り、枝を広げて成長していくように、私たちも鵜の木の地域に深く根ざし、地域の皆様と共に成長していきたい。そして、地域の拠り所となる場所を目指しています。
              </p>
              <p className="leading-relaxed" style={{ color: '#3A3D3F' }}>
                盆踊り大会などの地域イベントにも積極的に参加し、地域の一員として、皆様と共に歩んでいます。
              </p>
            </div>
            <div className="order-1 md:order-2">
              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/e2f7a91df5d7f77d10aed45c0e015a03.webp"
                  alt="さかなの木 名前の由来"
                  className="w-full rounded-lg shadow-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Strengths Section */}
      <section 
        className="py-20 relative"
      >
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
            alt="背景"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-white/85 via-white/80 to-white/85"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-16">
            <span className="text-primary text-sm font-bold tracking-wider">OUR STRENGTHS</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-2" style={{ color: '#3A3D3F' }}>私たちの強み</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {/* 産地直送の新鮮魚介 */}
            <div className="bg-white/95 backdrop-blur-sm rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="h-56 overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/db7457e0e6f89e80f1b7ab8f1bf9060f.jpeg"
                  alt="産地直送の新鮮魚介"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-8">
                <div className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-6 overflow-hidden relative">
                  <img
                    src="https://public.readdy.ai/ai/img_res/591deaedeb8d6c50fc2ff0c257c5d981.jpg"
                    alt="新鮮魚介"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-xl font-bold mb-4 text-center" style={{ color: '#3A3D3F' }}>産地直送の新鮮魚介</h3>
                <p className="leading-relaxed text-center" style={{ color: '#3A3D3F' }}>
                  毎日市場から届く新鮮な魚介を、いけじめ・神絞めで丁寧に処理。鮮度と旨味を最大限に引き出します。
                </p>
              </div>
            </div>

            {/* 小皿スタイル */}
            <div className="bg-white/95 backdrop-blur-sm rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="h-56 overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/e58742966538d819c30edb2b96d9974d.webp"
                  alt="小皿スタイル"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-8">
                <div className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-6 overflow-hidden relative">
                  <img
                    src="https://readdy.ai/api/search-image?query=Japanese%20small%20plates%20and%20dishes%20illustration%20with%20clean%20simple%20background%2C%20colorful%20appetizers%20arrangement%2C%20minimalist%20Japanese%20style%20icon%20design%2C%20professional%20food%20illustration&width=200&height=200&seq=concept-icon-dishes-1&orientation=squarish"
                    alt="小皿料理"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-xl font-bold mb-4 text-center" style={{ color: '#3A3D3F' }}>小皿スタイル</h3>
                <p className="leading-relaxed text-center" style={{ color: '#3A3D3F' }}>
                  一品一品を小皿でご提供。お一人様でも多彩な料理をお楽しみいただけ、お酒との相性も抜群です。
                </p>
              </div>
            </div>

            {/* 豊富な日本酒 */}
            <div className="bg-white/95 backdrop-blur-sm rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="h-56 overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/82ed58ac8454e0294110c64cd63e77c4.webp"
                  alt="豊富な日本酒"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-8">
                <div className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-6 overflow-hidden relative">
                  <img
                    src="https://readdy.ai/api/search-image?query=Japanese%20sake%20bottle%20and%20cup%20illustration%20with%20clean%20simple%20background%2C%20traditional%20sake%20serving%20set%2C%20minimalist%20Japanese%20style%20icon%20design%2C%20professional%20beverage%20illustration&width=200&height=200&seq=concept-icon-sake-1&orientation=squarish"
                    alt="日本酒"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-xl font-bold mb-4 text-center" style={{ color: '#3A3D3F' }}>豊富な日本酒</h3>
                <p className="leading-relaxed text-center" style={{ color: '#3A3D3F' }}>
                  15種類以上の厳選日本酒を季節ごとにご用意。100mlからお楽しみいただけるので、料理に合わせて様々な銘柄をお試しいただけます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Strengths */}
      <section 
        className="py-20 relative"
      >
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
            alt="背景"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <span className="text-primary text-sm font-bold tracking-wider">MORE FEATURES</span>
              <h3 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#3A3D3F' }}>
                その他のこだわり
              </h3>
              <p className="text-lg" style={{ color: '#3A3D3F' }}>
                お客様に快適にお過ごしいただくための、細やかな配慮
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-8">
              {/* 抜群のアクセス */}
              <div className="group bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-primary to-primary/80 rounded-2xl flex-shrink-0 shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-map-pin-line text-3xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#3A3D3F' }}>抜群のアクセス</h4>
                    <p className="leading-relaxed" style={{ color: '#3A3D3F' }}>
                      東急多摩川線の鵜の木駅より<strong className="text-primary">徒歩30秒</strong>。駅からすぐの好立地で、お仕事帰りやお買い物の後にも気軽にお立ち寄りいただけます。
                    </p>
                  </div>
                </div>
              </div>

              {/* 秋田県産の野菜 */}
              <div className="group bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-primary to-primary/80 rounded-2xl flex-shrink-0 shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-leaf-line text-3xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#3A3D3F' }}>秋田県産の野菜</h4>
                    <p className="leading-relaxed" style={{ color: '#3A3D3F' }}>
                      野菜は<strong className="text-primary">秋田県産の産直野菜</strong>を使用。新鮮で味わい深い野菜を、魚介と共にお楽しみいただけます。
                    </p>
                  </div>
                </div>
              </div>

              {/* こだわりのビール */}
              <div className="group bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-primary to-primary/80 rounded-2xl flex-shrink-0 shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-beer-line text-3xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#3A3D3F' }}>こだわりのビール</h4>
                    <p className="leading-relaxed" style={{ color: '#3A3D3F' }}>
                      ビールは<strong className="text-primary">瓶ビールのみ</strong>をご提供。サッポロ、アサヒ、キリン、サントリーなど、各種取り揃えております。
                    </p>
                  </div>
                </div>
              </div>

              {/* 無料Wi-Fi完備 */}
              <div className="group bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-primary to-primary/80 rounded-2xl flex-shrink-0 shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-wifi-line text-3xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#3A3D3F' }}>無料Wi-Fi完備</h4>
                    <p className="leading-relaxed" style={{ color: '#3A3D3F' }}>
                      店内では<strong className="text-primary">無料Wi-Fi</strong>をご利用いただけます。お仕事の合間や、ゆっくりとお食事をお楽しみください。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Owner Profile Section */}
      <section 
        className="py-20 relative"
      >
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
            alt="背景"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <span className="text-primary text-sm font-bold tracking-wider">OWNER PROFILE</span>
              <h2 className="text-3xl md:text-4xl font-bold mt-2" style={{ color: '#3A3D3F' }}>代表挨拶</h2>
            </div>
            <div className="rounded-lg shadow-lg p-8 md:p-12" style={{ backgroundColor: '#d4edeb' }}>
              <div className="grid md:grid-cols-3 gap-8 items-center">
                <div className="md:col-span-1">
                  <img
                    src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/488814045f8b783dec919162c77b149d.webp"
                    alt="代表 工藤貴朗"
                    className="w-48 h-48 rounded-full mx-auto object-cover shadow-lg"
                  />
                  <div className="text-center mt-6">
                    <p className="text-sm text-gray-600 mb-1">代表</p>
                    <p className="text-xl font-bold" style={{ color: '#3A3D3F' }}>工藤 貴朗</p>
                  </div>
                </div>
                <div className="md:col-span-2">
                  <p className="leading-relaxed mb-4" style={{ color: '#3A3D3F' }}>
                    大田区は私の地元です。約20年間、他の地域で修行を積み、料理の技術と心を学びました。
                  </p>
                  <p className="leading-relaxed mb-4" style={{ color: '#3A3D3F' }}>
                    子供が生まれたことをきっかけに地元に戻り、約10年間この鵜の木の地で暮らしてきました。子供とすぐに会える場所で、地域の皆様に愛されるお店を作りたい。そんな想いから、この場所でお店を開きました。
                  </p>
                  <p className="leading-relaxed mb-4" style={{ color: '#3A3D3F' }}>
                    元々和食の料理人として経験を積んできたため、魚料理には特に自信があります。毎日市場から届く新鮮な魚を、最高の状態でお客様にお届けすることが私の使命です。
                  </p>
                  <p className="leading-relaxed" style={{ color: '#3A3D3F' }}>
                    地域の皆様と共に成長し、この鵜の木の地で長く愛されるお店を目指してまいります。ぜひ、お気軽にお立ち寄りください。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-20 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: '#3A3D3F' }}>
            ご来店をお待ちしております
          </h2>
          <p className="text-lg mb-8" style={{ color: '#3A3D3F' }}>
            新鮮な魚介と温かいおもてなしで、皆様をお迎えいたします
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:03-6715-0369"
              className="inline-flex items-center justify-center gap-3 px-10 py-5 bg-gradient-to-r from-[#B9A176] to-[#D4C4A0] text-white rounded-full text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
              style={{ boxShadow: '0 8px 20px rgba(185, 161, 118, 0.4)' }}
            >
              <i className="ri-phone-line text-2xl"></i>
              <span>電話予約</span>
            </a>
            <a
              href="https://page.line.me/278ynzvw?oat_content=url&openQrModal=true"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 px-10 py-5 bg-gradient-to-r from-[#06C755] to-[#05B04D] text-white rounded-full text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
              style={{ boxShadow: '0 8px 20px rgba(6, 199, 85, 0.4)' }}
            >
              <i className="ri-line-fill text-2xl"></i>
              <span>LINE予約</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ConceptPage;
